module.exports = __webpack_public_path__ + "img/title2.0425b5c1.png";